export const VERSION = '1.4.0'
export const ENVELOPE_VERSION = '1.4.0'
export const EVENT_DETAIL_TYPE =
  'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1'
export const EVENT_CATEGORY = 'simpleUi'
export const MODES = {
  // Currently no modes are used in the codebase
  // Add mode values here if/when needed
}
